import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubjectsSetup from "Administrator/routes/AcademicSetup/routes/SubjectsSetup";
import { injectReducer } from "store/reducers";

export default store => ({
  path: ":academicId/",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "Administrator/routes/AcademicSetup/modules/AcademicSetupModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "academicSetup",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [SubjectsSetup(store)],
});
